// components/bol/ship-order-item.js
// Verstuur 1 orderregel naar backend (Bol-ship + labelinfo), met robuuste error handling.

const shipOrderItem = async (account, auth, order, orderItem, extra = {}) => {
  // 1) Accountgegevens veilig samenstellen (fallback naar order.origin?.account)
  const srcAccount = account || order?.origin?.account || {};
  const accountData = {
    accountName: srcAccount.accountName,
    mongoDbId: srcAccount.accountId,
    accountSaleNumber: srcAccount.accountSaleNumber,
  };

  // 2) Assistant optioneel uit sessionStorage
  let assistant = false;
  try {
    const raw = sessionStorage.getItem("assistant");
    if (raw) assistant = JSON.parse(raw) || false;
  } catch (_) {}

  // 3) Idempotency key (voorkomt dubbel shippen bij dubbele clicks/retries)
  const idemKey =
    orderItem?.orderItemId ||
    `${order?.orderId || "order"}:${orderItem?.offer?.reference || "item"}`;

  // 4) Abort/timeout
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 30_000); // 30s

  // 5) Request body – stuur alle relevante info naar de backend
  const body = {
    account: accountData,
    order,
    orderItem,
    user: auth,
    assistant,

    // 🔹 Nieuw: extra PostNL / label info zodat backend kan opslaan
    transporterCode: extra.transporterCode || order?.frontEndChosenDeliveryOption?.transporterCode,
    trackAndTrace:
      extra.trackAndTrace ||
      order?.inputTrackAndTrace ||
      order?.frontEndChosenDeliveryOption?.inputTrackAndTrace,
    shipmentPostNL: extra.shipmentPostNL || order?.shipmentPostNL || null,
    ownReference: extra.ownReference || order?.inputOwnReference || null,


    // ✅ nieuw: zorg dat backend entityId ziet
  frontEndChosenDeliveryOption: order?.frontEndChosenDeliveryOption || null,
  entityId: order?.frontEndChosenDeliveryOption?.entityId || extra.entityId || null,

    // Optioneel metadata voor identificatie
    orderId: extra.orderId || order?.orderId,
    orderDbId: extra.orderDbId || order?._id,
    orderItemId: extra.orderItemId || orderItem?.orderItemId,
    ean: extra.ean || orderItem?.product?.ean,
    sku: extra.sku || orderItem?.product?.productData?.sku,
    quantity: extra.quantity || orderItem?.quantity || 1,
  };

  console.log("ship payload", body);

  try {
    const res = await fetch(
      `${process.env.REACT_APP_ASSET_URL}/bol/orders/ship-order-item`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${auth?.token}`,
          "X-Idempotency-Key": idemKey,
        },
        body: JSON.stringify(body),
        signal: controller.signal,
      }
    );

    // 6) JSON alleen proberen te parsen als er (waarschijnlijk) JSON is
    const contentType = res.headers.get("content-type") || "";
    const canParseJson = contentType.includes("application/json");
    let data = null;

    if (res.status !== 204 && canParseJson) {
      try {
        data = await res.json();
      } catch (_) {
        // body was leeg of geen geldige json; laat data = null
      }
    }

    clearTimeout(timeout);

    // 7) Consequente return shape
    if (res.ok || res.status === 202) {
      return {
        ok: true,
        status: res.status,
        data,
      };
    } else {
      return {
        ok: false,
        status: res.status,
        error: data?.message || data || "Shippen mislukt",
      };
    }
  } catch (err) {
    clearTimeout(timeout);
    const aborted = err?.name === "AbortError";
    return {
      ok: false,
      status: aborted ? 408 : 0,
      error: aborted
        ? "Timeout/verbinding onderbroken"
        : err?.message || "Netwerkfout",
    };
  }
};

export default shipOrderItem;
